// 💾 src/components/layout/LanguageCurrencyDropdown.tsx
import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import "./style/Language.scss"
import languageIcon from "../../assets/images/languageIcon.png"

const languages = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "ar", label: "العربية" },
  { code: "el", label: "Ελληνικά" },
  { code: "cs", label: "Čeština" },
  { code: "bg", label: "български" }
]

const currencies = [
  { code: "usd", label: "USD-$" },
  { code: "eur", label: "EUR-€" },
  { code: "ars", label: "ARS-AR$" },
  { code: "bhd", label: "BHD-د.ب" },
  { code: "bdt", label: "BDT-৳" },
  { code: "bob", label: "BOB-$b" }
]

const LanguageCurrencyDropdown = () => {
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { lng } = useParams()

  const [open, setOpen] = useState(false)
  const [langSearch, setLangSearch] = useState("")
  const [currSearch, setCurrSearch] = useState("")
  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem("currency") || "usd"
  )

  const ref = useRef<HTMLDivElement>(null)

  const toggle = () => setOpen((prev) => !prev)

  const handleClickOutside = (e: MouseEvent) => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleClickOutside)
    } else {
      document.removeEventListener("mousedown", handleClickOutside)
    }
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [open])

  const filteredLanguages = languages.filter((l) =>
    l.label.toLowerCase().includes(langSearch.toLowerCase())
  )

  const filteredCurrencies = currencies.filter((c) =>
    c.label.toLowerCase().includes(currSearch.toLowerCase())
  )

const switchLanguage = (code: string) => {
  const pathParts = location.pathname.split("/")
  pathParts[1] = code
  const newPath = pathParts.join("/") || `/${code}`

  i18n.changeLanguage(code)
  navigate(newPath, { replace: true })
  setOpen(false)
}


  return (
    <div className="lang-currency-wrapper" ref={ref}>
      <button className="icon-button" onClick={toggle} title="Language & Currency">
        <img src={languageIcon} />
      </button>

      {open && (
        <div className="lang-currency-dropdown">
          <div className="columns">
            <div className="column">
              <strong>Language</strong>
              <input
                type="text"
                placeholder="Search"
                value={langSearch}
                onChange={(e) => setLangSearch(e.target.value)}
              />
              <ul>
                {filteredLanguages.map(({ code, label }) => (
                  <li
                    key={code}
                    className={i18n.language === code ? "active" : ""}
                    onClick={() => switchLanguage(code)}
                  >
                    {label}
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>
      )}
    </div>
  )
}

export default LanguageCurrencyDropdown
